import { useParams } from 'react-router-dom';

import { type ExpenseAccount } from 'modules/bookkeep/settings/accounting';
import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

import { GET_EXPENSE_ACCOUNT } from './query';

type RawData = {
  company: {
    chartOfAccounts: {
      expenseAccounts: {
        edges: {
          node: {
            id: string;
            name: string;
            code: string;
            isDefault: boolean;
            isArchived: boolean;
            isAvailable: boolean;
          };
        }[];
      };
    };
  };
};

export const useExpenseAccountQuery = (
  id: string | undefined | null,
  isEnabled = true,
): QueryState<ExpenseAccount | undefined> => {
  const { company: companyId } = useParams();

  const filter = {
    ids: id ? [id] : [],
    includeArchived: true,
  };

  return useQuery<ExpenseAccount, RawData>({
    key: ['useExpenseAccountQuery', companyId, filter],
    options: {
      cacheTime: 10 * 60 * 1000, // 10min,
      staleTime: 10 * 60 * 1000, // 10min,
    },
    isEnabled,
    request: {
      type: 'graphQL',
      target: 'v2',
      query: GET_EXPENSE_ACCOUNT,
      variables: {
        filter,
      },
    },
    reshapeData: (rawData) => {
      const { edges } = rawData.company.chartOfAccounts.expenseAccounts;
      return edges.map(({ node }) => node)[0];
    },
  });
};
